import { createSelector, createFeatureSelector } from '@ngrx/store';
import * as fromNotification from '../_reducers/notification';

export const selectNotificationState =
  createFeatureSelector<fromNotification.NotificationState>('notifications');

export const selectAllNotifications = createSelector(
  selectNotificationState,
  fromNotification.selectAll
);

export const selectNotificationEntities = createSelector(
  selectNotificationState,
  fromNotification.selectEntities
);

export const selectNotificationById = (id: number) =>
  createSelector(selectNotificationEntities, (entities) => entities[id]);

export const selectNotificationTotal = createSelector(
  selectNotificationState,
  fromNotification.selectTotal
);
